import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from 'ui/components/shared';
import { spacing } from 'ui/theme/utils';


export const Card = ({ variant, label, value = 0, isActive, onPinClick, ...rest }) => {
  const handlePinClick = (event) => {
    if (onPinClick) {
      event.stopPropagation();
      onPinClick(event);
    }
  };

  return (
    <CardWrapper variant={variant} isActive={isActive} {...rest}>
      {isActive && variant !== 'small' && <Pin onClick={handlePinClick} />}
      <Label variant={variant}>{label}</Label>
      <Value variant={variant}>{value}</Value>
    </CardWrapper>
  );
};

const CardWrapper = styled.div.attrs(({ variant, px = 'xs', py, dataCy }) => ({
  px,
  py: py || variant === 'small' ? '7px' : 0,
  'data-cy': dataCy,
}))`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  ${({ variant }) => {
    switch (variant) {
      case 'small':
        return css`
          min-width: ${({ minWidth = '125px' }) => minWidth};
          width: 100%;
        `;
      default:
        return css`
          width: 100%;
          min-height: ${({ minHeight = '95px' }) => minHeight};
        `;
    }
  }}
  background-color: ${({ bg = '#888' }) => bg};
  opacity: ${({ isActive }) => (isActive === undefined || isActive === true ? 1 : 0.28)};
  color: ${({ color = '#fff' }) => color};
  border-radius: 8px;
  cursor: pointer;
  ${(props) => spacing(props)}
`;

const Label = styled.label`
  text-align: left;
  font-weight: bold;
  ${({ variant }) => {
    switch (variant) {
      case 'small':
        return css`
          font-size: 14px;
          margin-right: ${({ theme }) => theme.spacing.xs};
        `;
      default:
        return css`
          font-size: 18px;
        `;
    }
  }}
  letter-spacing: 0.97px;
  color: inherit;
  cursor: inherit;
`;

const Value = styled.span`
  text-align: left;
  font-weight: bold;
  ${({ variant }) => {
    switch (variant) {
      case 'small':
        return css`
          font-size: 16px;
          letter-spacing: 0.7px;
        `;
      default:
        return css`
          font-size: 42px;
          letter-spacing: 2.54px;
        `;
    }
  }}
  color: inherit;
`;

const Pin = styled.span.attrs(() => ({
  children: <Icon src="/assets/img/icons/push-pin.svg" alt="pin" size="15px" />,
}))`
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 6px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.16));
  cursor: pointer;
`;
